export const ENetworkElementsFields = {
	directSftp: 'directSftp',
	autoSwitch: 'autoSwitch',
	pathCu: 'pathCu',
	pathDu: 'pathDu',
	netconfPort: 'netconfPort',
	type: 'type',
	middlewareId: 'middlewareId',
	name: 'name',
	ipAddress: 'ipAddress',
	userName: 'userName',
	password: 'password',
	subscription: 'subscription',
	lastVesTimePeriod: 'lastVesTimePeriod',
	netconfCheckTimePeriod: 'netconfCheckTimePeriod',
} as const;
